import $ from 'jquery'

export default {
    name: 'param-sfe',
    components: {},
    props: [],
    data() {
        return {
            is_loading: false,
            save_loading: false,
            is_readonly: true,

            info_sfe: {
                ifu: "",
                nim: "",
                jeton: ""
            }
        }
    },

    computed: {
        sfe_configs() {
            return this.$store.getters["sfe_configs"];
        },
    },

    mounted() {
        this.getSFEInfo()
    },

    methods: {
        async getSFEInfo() {
            this.is_loading = true

            this.$store.dispatch('getConfigInfoClinique', 'info_sfe').then(() => {
                this.initFields()
            })
        },

        initFields() {
            const fld_keys = Object.keys(this.info_sfe);
            fld_keys.forEach((key) => {
                this.info_sfe[key] = this.sfe_configs[key]

                this.is_loading = false
            });
        },

        editInfoSFE() {
            this.is_readonly= false

            if (!this.is_readonly) {
                $('#ifu').focus()
            }
        },

        async saveInfoSFE() {
            const isValid = await this.$refs.sfe_form.validate();

            if (!isValid) {
                return;
            }

            console.log(this.info_sfe);

            this.save_loading= true

            let form_data = new FormData();
            for (let key in this.info_sfe) {
                form_data.append(key, this.info_sfe[key])
            }
            form_data.append('data_type', 'info_sfe')

            this.$store.dispatch('saveConfigInfoClinique', form_data).then((response) => {
                if (response > 0) {
                    this.successToast("Information SFE configurée avec succès")
                    this.getSFEInfo()
                }

                this.save_loading = false
                this.is_readonly = true
            }).catch(() => {
                this.errorToast("Une erreur s'est produite! Merci de vérifier la connexion internet.")
                this.save_loading = false
            })
        }
    }
}